import { render, staticRenderFns } from "./ed-register-profile.component.vue?vue&type=template&id=641861a2&scoped=true&"
import script from "./ed-register-profile.component.ts?vue&type=script&lang=ts&"
export * from "./ed-register-profile.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-register-profile.component.scss?vue&type=style&index=0&id=641861a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641861a2",
  null
  
)

export default component.exports